import { RatePackageBulkUpsertLandingComponent } from './rate-package-bulk-upsert-landing.component';

export const containers: any[] = [RatePackageBulkUpsertLandingComponent];

export * from './rate-package-bulk-upsert-landing.component';